import Box from 'common/components/Box';
import Heading from 'common/components/Heading';
import Image from 'common/components/Image';
import Container from 'common/components/UI/Container';
import { graphql, Link, useStaticQuery } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';
import Section, {
	BannerContent, BannerContentWrapper, BannerText, Figure,
	HighlightedText
} from './banner.style';

const Banner = () => {
  const data = useStaticQuery(graphql`
    query {
			appJson {
				bannerData {
					button {
						id
						link
						thumb {
							publicURL
						}
						title
					}
					news
					newsLabel
					text
					title
				}
			}
			bannerCover: file(
        relativePath: { eq: "image/app/banner_image.png" }
      ) {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: BLURRED
            formats: [AUTO, WEBP]
          )
        }
      }
    }
  `);

	const { appJson: bannerData, bannerCover } = data;
	const { title, text, button, news, newsLabel } = bannerData?.bannerData;
	
	// Get the Gatsby image data
	const bannerImage = bannerCover?.childImageSharp?.gatsbyImageData ? 
	  getImage(bannerCover?.childImageSharp?.gatsbyImageData) : null;

	return (
		<Section id="home">
			<Container width="1400px">
				<BannerContentWrapper>
					<BannerContent>
						<HighlightedText>
							<strong>{news}</strong>
							{newsLabel}
						</HighlightedText>
						<Heading
							as="h1"
							className="animate__animated animate__fadeInUp banner-title"
							content={title}
						/>
						<BannerText>
							<div className="animate__animated animate__fadeInUp">
									{text}
							</div>
						</BannerText>
						{button.length > 0 ?
						<Box as="div" className="button-group">
							{button?.map((item) => {
								return (
									<Link
										to={item?.link}
										key={item?.id}
										target="_blank"
										rel="noopener noreferrer"
										aria-label={`Download Furbuz from ${item?.title}`}
									>
										<Image src={item?.thumb?.publicURL} alt={item?.title} />
									</Link>
								)
							})}
						</Box>
						: ""}
					</BannerContent>
					<Figure className="animate__animated animate__fadeInUp animate__fast">
						{bannerImage && (
							<GatsbyImage
								image={bannerImage}
								objectFit="contain"
								alt="Furbuz pet care app screens"
							/>
						)}
					</Figure>
				</BannerContentWrapper>
			</Container>
		</Section>
	);
};

export default Banner;
